/**
 * Promoção Ovos de Páscoa — estado em localStorage, modal nativo <dialog>
 */
(function () {
  const root = document.querySelector('[data-easter-egg-promo]');
  if (!root) return;

  const cfg = root.querySelector('[data-easter-config]');
  let config = {};
  try {
    config = JSON.parse(cfg?.textContent || '{}');
  } catch (_) {
    return;
  }

  const storageKey = config.storageKey;
  const autoPopupDelayMs = Math.max(0, Number(config.autoPopupDelayMs) || 0);
  const designMode = Boolean(config.designMode);

  const dialog = root.querySelector('dialog[data-easter-dialog]');
  const savedPanel = root.querySelector('[data-easter-saved]');
  const savedCodeEl = root.querySelector('[data-saved-code]');
  const savedCodeRow = root.querySelector('[data-saved-code-row]');
  const savedProductWrap = root.querySelector('[data-saved-product]');
  const savedProductLink = root.querySelector('[data-saved-product-link]');
  const savedProductImg = root.querySelector('[data-saved-product-img]');
  const gridWrap = root.querySelector('[data-easter-grid-wrap]');
  const grid = root.querySelector('[data-easter-grid]');
  const reveal = root.querySelector('[data-easter-reveal]');
  const revealCodeEl = root.querySelector('[data-reveal-code]');
  const revealPaperOrder = root.querySelector('[data-reveal-paper-order]');
  const revealProduct = root.querySelector('[data-reveal-product]');
  const revealProductImg = root.querySelector('[data-reveal-product-img]');
  const revealProductTitle = root.querySelector('[data-reveal-product-title]');
  const revealProductLink = root.querySelector('[data-reveal-product-link]');
  const revealCodeProduct = root.querySelector('[data-reveal-code-product]');
  const closeBtn = root.querySelector('[data-easter-close]');
  const copyRevealBtn = root.querySelector('[data-easter-copy-reveal]');
  const copySavedBtn = root.querySelector('[data-easter-copy-saved]');
  const doneBtn = root.querySelector('[data-easter-done]');
  const launcher = root.querySelector('[data-easter-launcher]');

  /** @param {unknown[]} arr */
  function shuffleInPlace(arr) {
    for (let i = arr.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [arr[i], arr[j]] = [arr[j], arr[i]];
    }
    return arr;
  }

  /** @typedef {{ discountType?: string, coupon?: string, productUrl?: string, productImage?: string, productTitle?: string }} EasterEggDef */

  function buildEggGridFromPool() {
    if (designMode || !grid) return;
    const poolEl = root.querySelector('[data-easter-egg-pool]');
    let pool = null;
    try {
      pool = JSON.parse(poolEl?.textContent || 'null');
    } catch (_) {
      return;
    }
    if (!pool || !Array.isArray(pool.eggs)) return;

    const maxVisible = Math.min(3, Math.max(1, Number(pool.maxVisible) || 3));
    /** @type {EasterEggDef[]} */
    let eggs = pool.eggs.filter((e) => e && typeof e === 'object');
    if (eggs.length > maxVisible) {
      eggs = shuffleInPlace([...eggs]).slice(0, maxVisible);
    }

    const closed = pool.closedEgg && typeof pool.closedEgg === 'object' ? pool.closedEgg : {};
    const src = typeof closed.src === 'string' ? closed.src : '';
    const width = typeof closed.width === 'number' ? closed.width : 400;
    const height = typeof closed.height === 'number' ? closed.height : null;

    grid.replaceChildren();
    for (const egg of eggs) {
      const coupon = typeof egg.coupon === 'string' ? egg.coupon.trim() : '';
      const discountType = egg.discountType === 'product' ? 'product' : 'order';
      const productUrl = typeof egg.productUrl === 'string' ? egg.productUrl.trim() : '';
      if (!coupon) continue;
      if (discountType === 'product' && !productUrl) continue;

      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'easter-egg-promo__egg';
      btn.setAttribute('data-easter-egg', '');
      btn.setAttribute('data-discount-type', discountType);
      btn.setAttribute('data-coupon', coupon);
      if (productUrl) {
        btn.setAttribute('data-product-url', productUrl);
        if (egg.productImage) btn.setAttribute('data-product-image', String(egg.productImage));
        if (egg.productTitle) btn.setAttribute('data-product-title', String(egg.productTitle));
      }

      const img = document.createElement('img');
      img.src = src;
      img.alt = '';
      img.width = width;
      if (height != null) img.height = height;
      img.loading = 'lazy';
      img.decoding = 'async';
      img.setAttribute('fetchpriority', 'low');
      btn.appendChild(img);
      grid.appendChild(btn);
    }
  }

  buildEggGridFromPool();

  /** @typedef {{ code?: string, discountType?: string, productUrl?: string, productImage?: string, productTitle?: string }} EasterState */

  /** Data local do navegador no formato YYYY-MM-DD (virada do dia na meia-noite local). */
  function getLocalCalendarDateKey(ms = Date.now()) {
    const d = new Date(ms);
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${y}-${m}-${day}`;
  }

  function clearEasterStorage() {
    try {
      localStorage.removeItem(storageKey);
    } catch (_) {}
  }

  /** @returns {EasterState | null} */
  function readState() {
    try {
      const raw = localStorage.getItem(storageKey);
      if (!raw) return null;
      const data = JSON.parse(raw);
      if (!data || typeof data !== 'object') return null;

      const today = getLocalCalendarDateKey();
      let storedDay = null;
      if (typeof data.savedDay === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(data.savedDay)) {
        storedDay = data.savedDay;
      } else if (typeof data.savedAt === 'number' && Number.isFinite(data.savedAt)) {
        storedDay = getLocalCalendarDateKey(data.savedAt);
      }

      if (storedDay !== today) {
        clearEasterStorage();
        return null;
      }

      if (data.v === 2) {
        return {
          code: typeof data.code === 'string' ? data.code : '',
          discountType: typeof data.discountType === 'string' ? data.discountType : 'order',
          productUrl: typeof data.productUrl === 'string' ? data.productUrl : '',
          productImage: typeof data.productImage === 'string' ? data.productImage : '',
          productTitle: typeof data.productTitle === 'string' ? data.productTitle : '',
        };
      }
      if (data.code && typeof data.code === 'string' && data.code.length > 0) {
        return { code: data.code, discountType: 'order' };
      }
    } catch (_) {}
    return null;
  }

  /** @param {EasterState} payload */
  function writeState(payload) {
    try {
      const now = Date.now();
      localStorage.setItem(
        storageKey,
        JSON.stringify({
          v: 2,
          code: payload.code || '',
          discountType: payload.discountType || 'order',
          productUrl: payload.productUrl || '',
          productImage: payload.productImage || '',
          productTitle: payload.productTitle || '',
          savedAt: now,
          savedDay: getLocalCalendarDateKey(now),
        })
      );
    } catch (_) {}
  }

  /** @param {EasterState | null} state */
  function showSaved(state) {
    if (!savedPanel) return;
    if (!state) {
      savedPanel.hidden = true;
      return;
    }
    const hasProduct = state.discountType === 'product' && Boolean(state.productUrl);
    const hasCode = Boolean(state.code && state.code.trim());
    if (!hasProduct && !hasCode) {
      savedPanel.hidden = true;
      return;
    }

    const isProduct = hasProduct;
    if (savedProductWrap && savedProductLink && savedProductImg) {
      if (isProduct) {
        savedProductWrap.hidden = false;
        savedProductLink.href = state.productUrl || '#';
        if (state.productImage) {
          savedProductImg.src = state.productImage;
          savedProductImg.hidden = false;
        } else {
          savedProductImg.removeAttribute('src');
          savedProductImg.hidden = true;
        }
        savedProductImg.alt = state.productTitle || '';
      } else {
        savedProductWrap.hidden = true;
        savedProductLink.href = '#';
        savedProductImg.removeAttribute('src');
      }
    }

    if (savedCodeEl) savedCodeEl.textContent = state.code || '';
    if (savedCodeRow) savedCodeRow.hidden = !hasCode;

    savedPanel.hidden = false;
  }

  let autoPromptTimerId = 0;

  function openDialogNow() {
    if (autoPromptTimerId) {
      window.clearTimeout(autoPromptTimerId);
      autoPromptTimerId = 0;
    }
    if (!dialog || dialog.open) return;
    dialog.showModal();
    syncDialogContentForOpen();
    const focusTarget = closeBtn || dialog.querySelector('button');
    focusTarget?.focus?.();
  }

  function scheduleAutoPromptIfNeeded() {
    if (designMode || autoPopupDelayMs <= 0 || !dialog) return;
    if (readState()) return;
    autoPromptTimerId = window.setTimeout(() => {
      autoPromptTimerId = 0;
      openDialogNow();
    }, autoPopupDelayMs);
  }

  const existing = readState();
  if (launcher) launcher.hidden = false;

  if (existing) {
    showSaved(existing);
  }

  if (!designMode && !existing) {
    scheduleAutoPromptIfNeeded();
  }

  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState !== 'visible' || designMode) return;
    const s = readState();
    showSaved(s);
  });

  launcher?.addEventListener('click', () => {
    openDialogNow();
  });

  function startLauncherIdleNudge() {
    if (!launcher) return;
    const img = launcher.querySelector('img');
    if (!img) return;
    const prefersReduced =
      typeof window.matchMedia === 'function' && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReduced) return;

    let timeoutId = 0;

    function armNextDelay() {
      if (timeoutId) window.clearTimeout(timeoutId);
      const delayMsNudge = 5500 + Math.random() * 9500;
      timeoutId = window.setTimeout(runNudge, delayMsNudge);
    }

    function runNudge() {
      timeoutId = 0;
      if (launcher.hidden || dialog?.open) {
        armNextDelay();
        return;
      }
      launcher.classList.add('easter-egg-promo__launcher--nudge');
    }

    launcher.addEventListener('animationend', (e) => {
      if (e.target !== img || e.animationName !== 'easter-launcher-nudge') return;
      launcher.classList.remove('easter-egg-promo__launcher--nudge');
      armNextDelay();
    });

    armNextDelay();
  }

  startLauncherIdleNudge();

  function setRevealVisible(visible) {
    if (!reveal) return;
    reveal.classList.toggle('is-visible', visible);
    reveal.setAttribute('aria-hidden', visible ? 'false' : 'true');
  }

  /** @param {boolean} productMode */
  function setRevealLayout(productMode) {
    if (revealPaperOrder) revealPaperOrder.hidden = productMode;
    if (revealProduct) revealProduct.hidden = !productMode;
  }

  /** @param {EasterState | null} state */
  function hasPlayedState(state) {
    if (!state) return false;
    const hasProduct = state.discountType === 'product' && Boolean(state.productUrl);
    const hasCode = Boolean(state.code && state.code.trim());
    return hasProduct || hasCode;
  }

  /** Preenche o painel revelado (cupom / produto) a partir do estado salvo ou recém-sorteado. */
  function fillRevealUi(/** @type {EasterState} */ payload) {
    if (!revealCodeEl) return;
    const productMode = payload.discountType === 'product' && Boolean(payload.productUrl);
    setRevealLayout(productMode);

    if (productMode) {
      revealCodeEl.textContent = '';
      const productMedia = revealProductImg?.closest('.easter-egg-promo__reveal-product-media');
      if (revealProductImg && payload.productImage) {
        revealProductImg.src = payload.productImage;
        revealProductImg.alt = payload.productTitle || '';
        if (productMedia) productMedia.hidden = false;
      } else if (revealProductImg) {
        revealProductImg.removeAttribute('src');
        revealProductImg.alt = '';
        if (productMedia) productMedia.hidden = true;
      }
      if (revealProductTitle) {
        revealProductTitle.textContent = payload.productTitle || '';
        revealProductTitle.hidden = !payload.productTitle;
      }
      if (revealProductLink && payload.productUrl) {
        revealProductLink.href = payload.productUrl;
      }
      const code = (payload.code || '').trim();
      if (revealCodeProduct) {
        revealCodeProduct.textContent = code;
        revealCodeProduct.hidden = false;
      }
      if (copyRevealBtn) {
        copyRevealBtn.hidden = false;
        copyRevealBtn.dataset.clipboard = code;
      }
    } else {
      revealCodeEl.textContent = payload.code || '';
      if (revealCodeProduct) {
        revealCodeProduct.textContent = '';
        revealCodeProduct.hidden = true;
      }
      if (copyRevealBtn) {
        copyRevealBtn.hidden = false;
        copyRevealBtn.dataset.clipboard = payload.code || '';
      }
    }

    setRevealVisible(true);
  }

  /** Mostra só a grade de ovos (visitante ainda não sorteou nesta sessão de modal). */
  function resetDialogToEggPicker() {
    if (gridWrap) gridWrap.classList.remove('is-hidden');
    setRevealVisible(false);
    setRevealLayout(false);
    if (revealCodeEl) revealCodeEl.textContent = '';
    if (revealCodeProduct) {
      revealCodeProduct.textContent = '';
      revealCodeProduct.hidden = true;
    }
    if (copyRevealBtn) {
      copyRevealBtn.hidden = false;
      copyRevealBtn.dataset.clipboard = '';
    }
    grid?.querySelectorAll('[data-easter-egg]').forEach((b) => {
      b.disabled = false;
      b.classList.remove('easter-egg-promo__egg--shake', 'easter-egg-promo__egg--pop');
    });
  }

  /** Abre direto na tela revelada com o cupom/produto já guardado. */
  function showSavedRevealInDialog(/** @type {EasterState} */ state) {
    if (gridWrap) gridWrap.classList.add('is-hidden');
    fillRevealUi(state);
  }

  function syncDialogContentForOpen() {
    const state = readState();
    if (hasPlayedState(state)) {
      showSavedRevealInDialog(/** @type {EasterState} */ (state));
    } else {
      resetDialogToEggPicker();
    }
    showSaved(state);
  }

  /** @param {HTMLButtonElement} eggBtn */
  function runRevealAnimation(eggBtn, /** @type {EasterState} */ payload) {
    if (!gridWrap || !grid || !reveal || !revealCodeEl) return;

    const reduced =
      typeof window.matchMedia === 'function' && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    eggBtn.disabled = true;
    if (!reduced) eggBtn.classList.add('easter-egg-promo__egg--shake');

    window.setTimeout(
      () => {
        if (!reduced) eggBtn.classList.add('easter-egg-promo__egg--pop');
      },
      reduced ? 0 : 380
    );

    window.setTimeout(
      () => {
        gridWrap.classList.add('is-hidden');
        fillRevealUi(payload);
        writeState(payload);
      },
      reduced ? 50 : 900
    );
  }

  grid?.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-easter-egg]');
    if (!btn || btn.disabled) return;

    const type = btn.getAttribute('data-discount-type') || 'order';
    const productUrl = btn.getAttribute('data-product-url') || '';
    const productImage = btn.getAttribute('data-product-image') || '';
    const productTitle = btn.getAttribute('data-product-title') || '';
    const coupon = (btn.getAttribute('data-coupon') || '').trim();
    if (!coupon) return;

    const isProduct = type === 'product' && productUrl.length > 0;
    if (type === 'product' && !isProduct) return;

    /** @type {EasterState} */
    const payload = isProduct
      ? {
          discountType: 'product',
          code: coupon,
          productUrl,
          productImage,
          productTitle,
        }
      : {
          discountType: 'order',
          code: coupon,
          productUrl: '',
          productImage: '',
          productTitle: '',
        };

    grid.querySelectorAll('[data-easter-egg]').forEach((b) => {
      b.disabled = true;
    });
    runRevealAnimation(btn, payload);
  });

  function closeModal() {
    dialog?.close();
    const state = readState();
    if (hasPlayedState(state)) showSaved(/** @type {EasterState} */ (state));
  }

  closeBtn?.addEventListener('click', () => {
    closeModal();
  });

  doneBtn?.addEventListener('click', () => {
    closeModal();
  });

  dialog?.addEventListener('cancel', () => {
    closeModal();
  });

  function copyText(text, btn) {
    if (!text) return;
    const fallback = () => {
      try {
        const ta = document.createElement('textarea');
        ta.value = text;
        ta.setAttribute('readonly', '');
        ta.style.position = 'fixed';
        ta.style.left = '-9999px';
        document.body.appendChild(ta);
        ta.select();
        document.execCommand('copy');
        document.body.removeChild(ta);
      } catch (_) {}
    };
    if (navigator.clipboard?.writeText) {
      navigator.clipboard.writeText(text).catch(fallback);
    } else {
      fallback();
    }
    if (btn) {
      const prev = btn.textContent;
      btn.textContent = btn.getAttribute('data-label-copied') || 'Copiado!';
      window.setTimeout(() => {
        btn.textContent = prev;
      }, 2000);
    }
  }

  copyRevealBtn?.addEventListener('click', () => {
    const fromDataset = copyRevealBtn.dataset.clipboard?.trim();
    const code = fromDataset || revealCodeEl?.textContent?.trim() || '';
    copyText(code, copyRevealBtn);
  });

  copySavedBtn?.addEventListener('click', () => {
    const code = savedCodeEl?.textContent?.trim() || '';
    copyText(code, copySavedBtn);
  });
})();
